import React, { useEffect, useState } from "react";
import PaymentSuccessGif from "../../assets/gif/sucess.gif";
import coversureLogo from "../../assets/svg/coversure-logo.svg";
import PrimaryButton from "../../components/Button/PrimaryButton";
import SendLogo from "../../assets/svg/send.svg";
import SendWhiteLogo from "../../assets/svg/send-white.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ROUTE_PATH from "../../constant/route";
import { AppDispatch } from "../../store/store";
import { showToast } from "../../components/Toast";
 
import CircularProgress from "@mui/material/CircularProgress";
import { fetchPaymentStatus } from "../../store/reducers/authentication/apiThunk";
const PaymentSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [params, setParams] = useState<any>({});

  let paymentData:string;
  let successUpdate: boolean;
 
  const [flag, setFlag] = useState(true);
  useEffect(() => {
    const queryParams = getQueryParams();
    setParams(queryParams);
    // Track payment success event with Facebook Pixel for DC partner only
   
    paymentData=queryParams?.paymentData;
    successUpdate=queryParams?.successUpdate;
    if (!queryParams?.isVerified) {
      navigate(ROUTE_PATH.WELLNESS);
    }
    
  }, []);

  useEffect(() => {
    let transactionTimer = Number(localStorage.getItem("transactionTimer"));
    statusAPI(transactionTimer);
  }, []);

  const recApi = (item: any) => {
    localStorage.setItem("transactionTimer", item);
    if (item === 100000) {
      localStorage.setItem("paymentSuccessStatus", "false");
      setFlag(false);
      localStorage.setItem("paymentFailedStatus", "true");
      navigate(ROUTE_PATH.FAILURE_PAYMENT);
      return;
    } else {
      statusAPI(item);
    }
  };

  const statusAPI = async (item: any) => {
    if (!successUpdate) {
      try {
        const res = await dispatch(
          fetchPaymentStatus(paymentData)
        ).unwrap(); // Unwraps to return raw result or throw error
        if (res?.status === 1) {
          if (res?.data?.status === "SUCCESS") {
           localStorage.setItem("paymentSuccessStatus", "true");
            setFlag(false);
            // auto redirect to wellness page after 2 seconds
            setTimeout(() => {
              localStorage.removeItem("dataForPayment");
              localStorage.removeItem("paymentSuccessStatus");
              localStorage.removeItem("transactionTimer");
              localStorage.setItem("reloadWellnessPage", "true");
              navigate(ROUTE_PATH.WELLNESS);
            }, 2000);
            return;
          } else {
            setFlag(true);
            localStorage.setItem("paymentSuccessStatus", "false");
            setTimeout(() => {
              recApi(item + 20000);
            }, 5000);
          }
        }
      } catch (error) {
        localStorage.setItem("paymentSuccessStatus", "false");
        setFlag(false);
        showToast("Something went wrong", "error");
        console.error("Error saving user data:", error);
      }
    }
  };


function getQueryParams() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const paramsRaw = Object.fromEntries(urlSearchParams.entries());
    return {
        isVerified: paramsRaw.isVerified === "true",       
        paymentData: paramsRaw.paymentData,                
        name: paramsRaw.name,
        email: paramsRaw.email,
        mobile: paramsRaw.mobile,
        successUpdate: paramsRaw.successUpdate === "true",
        totalPrice: paramsRaw.totalPrice ? Number(paramsRaw.totalPrice) : 0, 
        partnerCode: paramsRaw.partnerCode,
    };
  
  }
  return (
    <div className="sm:flex items-center justify-center w-[100%] h-[100vh] bg-bg-color-3 sm:bg-bg-color-5 relative">
      {flag ? (
        <div className="flex justify-center flex-col items-center pt-[20px] lg:p-[0]">
          <div className="font-bold text-[12px] flex items-center">
            <CircularProgress
              style={{
                marginRight: "5px",
              }}
              size="15px"
            />
            Please Wait...
          </div>
          <div className="font-bold text-[12px]">
            Your payment is currently being processed
          </div>
          <br />
          <div className="text-[12px]">
            Please do not refresh or close your browser.
          </div>
        </div>
      ) : (
        <>
        {/* web view */}
          <div className="md:block hidden bg-bg-color-3 pt-[20px] pb-[14px] px-[16px] sm:py-[30px] sm:pb-0 sm:w-[70%] lg:w-[60%]  xl:w-[45%] sm:px-[88px] sm:rounded-[30px] bg-bg-color-3 sm:shadow-custom-light">
            <div className="flex flex-col items-center justify-center sm:mb-[36px] mb-[24px]">
            <img src={PaymentSuccessGif} alt="Success" className="h-[100px] w-[100px]" />
              <div className="sm:text-[16px] text-[16px] sm:leading-[20px] leading-[20px] font-bold text-text-color-6 text-center ">
                Thank you!
                <br />
                Payment Successful
              </div>
              <div className="bg-bg-color-4 p-[30px] hidden sm:block rounded-[25px] mt-[16px] w-[100%] text-center text-">
                <div className="text-[14px] leading-[18px] font-bold text-bg-color-5 pb-[14px] flex items-center justify-center">
                  <img
                    src={SendWhiteLogo}
                    alt="SendLogo"
                    className="mr-[5px]"
                  />
                  Confirmation sent to{" "}
                  {params?.name}
                </div>
                <div className="text-[12px] leading-[18px] text-bg-color-5 pb-[4px]">
                  Email address : {params?.email}
                </div>
                <div className="text-[12px] leading-[18px] text-bg-color-5 pb-[14px]">
                  Mobile no. : {params?.mobile}
                </div>
                {/* <div className="text-[12px] leading-[18px] text-bg-color-5">
              It includes details on how to access your services, including
              HospiCash Insurance and Wellness Benefits.
            </div> */}
                <div className="text-[12px] leading-[18px] text-bg-color-5">
                It includes details on how to access wellness benefits.
                  {/* and CoverSure Platform. */}
                </div>
              </div>
              <div className="text-[11px] leading-[18px] py-[16px] text-text-color-8 font-semibold hidden sm:block">
                For any queries reach out to{" "}
                <a href="mailto:support@coversure.in">support@coversure.in</a>
              </div>
              <div className="w-[100%] hidden sm:block">
                <PrimaryButton
                  label={
                    <div className="flex items-center justify-center w-[100%] font-black">
                      <div className="text-[14px] leading-[18px] lg:text-[18px] lg:leading-[18px] font-semibold">
                        Restart client journey
                      </div>
                    </div>
                  }
                  onClick={() => {
                    navigate(ROUTE_PATH.WELLNESS);
                  }}
                  classname="w-[100%]"
                />
              </div>
            </div>
          </div>

          {/* mobile view */}
          <div className="md:hidden  w-[100%] block">
          <div className="bg-[#1E56FF] w-[100%] flex flex-col gap-4 items-center px-10 py-5 ">
                <img src={coversureLogo} alt="coversure" className="h-[21px]" />
                <img src={PaymentSuccessGif} alt="Success" className="h-[100px] w-[100px]" />
                <div className="text-center">
                  <h1 className="text-[20px] font-[900] text-white text-center">Your Payment is successful</h1>
                </div>
              </div>
              <div className="absolute bottom-0 w-[100%]">
            <div className="bg-[#F2F5FF] p-[16px] w-[100%]">
              <div className="text-[14px] leading-[18px] font-bold text-text-color-1 pb-[14px] flex items-center">
                <img src={SendLogo} alt="SendLogo" className="mr-[5px]" />
                Confirmation sent to{" "}
                {params?.name}
              </div>
              <div className="text-[12px] leading-[18px] text-text-color-1 pb-[4px]">
                Email address : {params?.email}
              </div>
              <div className="text-[12px] leading-[18px] text-text-color-1 pb-[14px]">
                Mobile no. : {params?.mobile}
              </div>
              {/* <div className="text-[12px] leading-[18px] text-text-color-1">
            It includes details on how to access your services, including
            HospiCash Insurance and Wellness Benefits.
          </div> */}
              <div className="text-[12px] leading-[18px] text-text-color-1">
                It includes details on how to access including Wellness Benefits
                and CoverSure Platform.
              </div>
              <div className="text-[11px] leading-[18px] pt-[10px] text-text-color-8 font-semibold text-center">
                For any queries reach out to{" "}
                <a href="mailto:support@coversure.in">support@coversure.in</a>
              </div>
            </div>
            <div
              className="bg-[#1f55ff] text-[#ffffff] w-[100%] p-[10px] text-center text-[12px] leading-[18px] font-semibold cursor-pointer"
              onClick={() => {
                localStorage.removeItem("dataForPayment");
                localStorage.removeItem("paymentSuccessStatus");
                localStorage.removeItem("transactionTimer");
                localStorage.setItem("reloadWellnessPage", "true");
                  navigate(ROUTE_PATH.WELLNESS);
              }}
            >
              Restart client journey
            </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PaymentSuccess;
